/**
 * "O que fazer agora" do comercial: ate quatro cartoes lidos da propria fila
 * (quem espera fora do SLA, janela de comissao acabando, vendedora com SLA
 * baixo, projecao do que ainda fecha). Cada cartao tem UMA acao, que recorta a
 * fila logo abaixo -- filtro e ordem de verdade, nao um link generico.
 */

import { Badge, Button, Icon, SectionCard, type BadgeTone } from '../../../components/ui';
import type { AcaoDaFila, AvisoDoComercial, TomDoAviso } from '../fila';

const TOM: Readonly<Record<TomDoAviso, { readonly label: string; readonly tone: BadgeTone; readonly borda: string; readonly icone: string }>> = {
  alerta: { label: 'Atenção', tone: 'warning', borda: 'border-status-warning/50', icone: 'bg-status-warning/15 text-status-warning' },
  oportunidade: { label: 'Oportunidade', tone: 'good', borda: 'border-status-good/40', icone: 'bg-status-good/10 text-status-good' },
  projecao: { label: 'Projeção', tone: 'info', borda: 'border-info/40', icone: 'bg-info/10 text-info' },
  bom: { label: 'Tudo em ordem', tone: 'good', borda: 'border-line', icone: 'bg-ink/5 text-ink-muted' },
};

export function OQueFazerAgoraComercial({ avisos, onAcao }: { readonly avisos: readonly AvisoDoComercial[]; readonly onAcao: (acao: AcaoDaFila) => void }): JSX.Element {
  const alertas = avisos.filter((a) => a.tom === 'alerta').length;
  return (
    <SectionCard
      id="o-que-fazer-agora"
      title="O que fazer agora"
      icon="clique"
      description="Lido da fila do período. Cada cartão recorta a fila logo abaixo."
      aside={
        alertas > 0 ? (
          <Badge tone="warning" dot>
            {alertas} {alertas === 1 ? 'atenção' : 'atenções'}
          </Badge>
        ) : undefined
      }
    >
      <ol className="grid gap-3 md:grid-cols-2 xl:grid-cols-4">
        {avisos.map((a, indice) => {
          const t = TOM[a.tom];
          return (
            <li key={a.key} className={`flex h-full flex-col gap-2 rounded-xl border bg-elevated px-4 py-3 ${t.borda}`}>
              <div className="flex items-center justify-between gap-2">
                <span className="flex items-center gap-2">
                  <span aria-hidden="true" className={`grid h-7 w-7 place-items-center rounded-lg ${t.icone}`}>
                    <Icon name={a.icone} size="sm" />
                  </span>
                  <Badge tone={t.tone}>{t.label}</Badge>
                </span>
                <span className="text-[10px] font-semibold uppercase tracking-wide text-ink-subtle">{indice + 1}º</span>
              </div>
              <h3 className="text-sm font-semibold leading-snug text-ink">{a.titulo}</h3>
              <p className="flex-1 text-xs leading-relaxed text-ink-muted">{a.texto}</p>
              {a.acao !== null && a.rotuloAcao !== null ? (
                <div>
                  <Button variant="secondary" size="sm" iconRight="seta-dir" onClick={() => (a.acao === null ? undefined : onAcao(a.acao))}>
                    {a.rotuloAcao}
                  </Button>
                </div>
              ) : null}
            </li>
          );
        })}
      </ol>
    </SectionCard>
  );
}
